import { action, makeObservable, observable } from "mobx";

import { fetchConfigFileWithDefault } from "../fetchConfig";

const DEFAULT_DATA_FORMATS = {
  modelName: {
    functions: [["ByPass"]],
  },
  key: {
    functions: [["ByPass"]],
  },
  value: {
    functions: [["ByPass"]],
  },
};

class DataFormatStore {
  dataFormats: { [key: string]: any } = {};

  setDataFormats(value: object) {
    this.dataFormats = value;
  }

  async fetchDataFormats() {
    const serverUrl = process.env.REACT_APP_SERVER_URL;
    const dataFormats = await fetchConfigFileWithDefault(
      "DataFormat.json",
      DEFAULT_DATA_FORMATS,
      serverUrl,
    );
    this.setDataFormats(dataFormats);
  }

  constructor() {
    makeObservable(this, {
      dataFormats: observable,
      setDataFormats: action,
    });
    this.setDataFormats = this.setDataFormats.bind(this);
    this.fetchDataFormats();
  }
}

export const dataFormatStore = new DataFormatStore();
